module.exports = __webpack_public_path__ + "img/aa284bc.png";